import * as React from 'react';
import { Button, Input, Modal } from '@ixicare/ui';
import { t } from '~/i18n';
import { Spacer } from '~components/Utils/Spacer';

interface Props {
  presetName: string | null;
  canEditPresets: boolean;
  isPending: boolean;
  onUpdatePreset: () => void;
  onSaveAsNew: (name: string) => void;
  onKeepCustom: () => void;
  onCancel: () => void;
}

export function ZoneSaveChoiceModal({
  presetName,
  canEditPresets,
  isPending,
  onUpdatePreset,
  onSaveAsNew,
  onKeepCustom,
  onCancel,
}: Props) {
  const [isNaming, setNaming] = React.useState(false);
  const [name, setName] = React.useState('');

  if (isNaming) {
    return (
      <Modal onClose={onCancel} style={{ maxWidth: 450 }}>
        <h3 className="text-center mb-10">{t('geofence.preset.name.title')}</h3>
        <p className="mb-15">{t('geofence.preset.name.description')}</p>
        <Spacer size={24} />
        <Input
          label={t('geofence.preset.nameLabel')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
        <Spacer size={24} />
        <Button
          className="mb-15"
          isBlock
          type="button"
          disabled={!name.trim() || isPending}
          onClick={() => onSaveAsNew(name.trim())}
        >
          {t('geofence.preset.create')}
        </Button>
        <Button isBlock buttonType="link" onClick={() => setNaming(false)}>
          {t('geofence.preset.name.back')}
        </Button>
      </Modal>
    );
  }

  return (
    <Modal onClose={onCancel} style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-10">
        {presetName ? t('geofence.preset.changed.title', { name: presetName }) : t('geofence.preset.new.title')}
      </h3>
      <p className="mb-15">
        {presetName ? t('geofence.preset.changed.description') : t('geofence.preset.new.description')}
      </p>
      <Spacer size={32} />
      {presetName && canEditPresets && (
        <Button className="mb-15" isBlock type="button" disabled={isPending} onClick={onUpdatePreset}>
          {t('geofence.preset.changed.update')}
        </Button>
      )}
      {canEditPresets && (
        <Button
          className="mb-15"
          isBlock
          type="button"
          buttonType={presetName ? 'primary-flat' : undefined}
          onClick={() => setNaming(true)}
        >
          {t('geofence.preset.changed.saveAsNew')}
        </Button>
      )}
      <Button className="mb-15" isBlock type="button" buttonType="link" onClick={onKeepCustom}>
        {t('geofence.preset.keep')}
      </Button>
      <Button isBlock buttonType="link" onClick={onCancel}>
        {t('global.cancel')}
      </Button>
    </Modal>
  );
}

export default ZoneSaveChoiceModal;
